import { GLOBAL_FILTER_CONSTS as GF } from '../consts'
import _ from 'lodash'

const defaultGlobalFilter = {
  allSelected: true,
  selections: [],
  isActive: true,
  checkedOption: 'filterByAirline',
}

const state = {
  globalFilter: defaultGlobalFilter,
  globalFilterConfirmation: true,
}

const getters = {
  globalFilter: () => {
    return state.globalFilter
  },

  selections: () => {
    if (
      state.globalFilter &&
      state.globalFilter.isActive &&
      state.globalFilter.selections.length > 0
    ) {
      return state.globalFilter.selections
    }

    return []
  },

  airlineIdsSelected: state => {
    if (
      state.globalFilter &&
      state.globalFilter.isActive &&
      state.globalFilter.selections.length > 0
    ) {
      const selections = state.globalFilter.selections
      const groupedAirlines = _.groupBy(selections, 'airlineId')
      const airlineIds = Object.keys(groupedAirlines).map(key => parseInt(key))
      return airlineIds
    }

    return []
  },

  masterModelIdsSelected: state => {
    if (
      state.globalFilter &&
      state.globalFilter.isActive &&
      state.globalFilter.selections.length > 0
    ) {
      const selections = state.globalFilter.selections
      const groupedMasterModels = _.groupBy(selections, 'masterModelId')
      const masterModelIds = Object.keys(groupedMasterModels).map(key =>
        parseInt(key),
      )
      return masterModelIds
    }

    return []
  },

  showAllAirlines: state => {
    return state.globalFilter.selections.length === 0
  },

  invalidGlobalFilterForPhmAgreements: (
    state,
    getters,
    rootState,
    rootGetters,
  ) => {
    const airlineIdsSelected = getters.airlineIdsSelected || []
    if (airlineIdsSelected.length > 0) {
      const phmAirlinesData =
        rootGetters['user/mappedUserAirlinesWithPhmAgreements']
      const allowedAirlineIds = phmAirlinesData.map(item => item.airlineId)
      const invalidAirlines = airlineIdsSelected.filter(
        item => !allowedAirlineIds.includes(item),
      )

      return invalidAirlines.length > 0
    }

    return false
  },
}

const actions = {
  async [GF.GET_GLOBAL_FILTER]({ commit }) {
    const ls = window.localStorage.getItem('global_filter_options')
    let gfs = ls ? JSON.parse(ls) : defaultGlobalFilter

    const keys = Object.keys(gfs)
    if (keys.length === 0) {
      gfs = defaultGlobalFilter
    }

    commit(GF.UPDATE_GLOBAL_FILTER, gfs)
  },

  async [GF.GET_GLOBAL_FILTER_CONFIRMATION]({ commit }) {
    const ls = window.localStorage.getItem('global_filter_confirmation')
    const gfsc = ls ? ls === 'true' : true
    commit(GF.UPDATE_GLOBAL_FILTER_CONFIRMATION, gfsc)
  },
}

const mutations = {
  [GF.UPDATE_GLOBAL_FILTER]: (state, data) => {
    state.globalFilter = data
    window.localStorage.setItem('global_filter_options', JSON.stringify(data))
  },
  [GF.UPDATE_GLOBAL_FILTER_CONFIRMATION]: (state, data) => {
    state.globalFilterConfirmation = data
    window.localStorage.setItem('global_filter_confirmation', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
